import { SubtitleStyled } from 'components/common/general/layouts/PageHeader/styles';
import React from 'react';
import { LinkStyled } from './styles';

const EmployeeHeaderSubtitle: React.FC = () => {
  return (
    <SubtitleStyled>
      Welcome to your benefits dashboard where you can enroll and manage your participation in your employer sponsored
      benefits. Depending on the time of year, the options on this page will change.{' '}
      <LinkStyled
        target="_blank"
        href="https://insurancemenu.zendesk.com/hc/en-us/articles/23905675387540-How-can-I-manage-my-benefits-on-InsuranceMenu"
        rel="noreferrer"
      >
        This help article
      </LinkStyled>{' '}
      outlines the most important things to know about this page.
    </SubtitleStyled>
  );
};

export default EmployeeHeaderSubtitle;
